import { IApplicationState } from '../../types/redux';

export const selectSavedSearchesNotification = (state: IApplicationState): boolean => {
  return state.savedSearchesNotification.visible;
};
